export const environment = {
  production: true,

  // Staging points at the same API/Auth0 tenant as prod for now; split when a
  // dedicated staging API exists.
  apiBaseUrl: 'https://api.advocad.app/api',
  // Assisted-capture Chrome extension ID (must match externally_connectable).
  advocadExtensionId: 'cnddpmkigifgohgbeejakhkjoekalcok',
  // Realm-style data routing: staging talks to the SAME API but points at the
  // DEV database, so staging testing never touches production data.
  db: {
    name: 'advocad_app_dev',
    activityCollection: 'activities',
    userProfileCollection: 'profiles',
  },
  auth0: {
    domain: 'advocad.uk.auth0.com',
    clientId: 'AcOS1jTgHvNUjzMzTwKP0Fl1aXklACGY',
    audience: 'https://api.advocad.app',
  },
  // PostHog (EU). Analytics only initialises on live production hosts
  // (advocad.app / advocad.ai), so a staging deploy — including
  // staging.advocad.ai — carries the key but stays silent off-domain.
  posthog: {
    key: 'phc_zvNyhqp2vnW7Xwg6FT59TQRVZwNQUSPYWKCJx5pFDH6Q',
    host: 'https://eu.i.posthog.com',
  },
  // Sentry error monitoring (EU). Like PostHog, only initialises on live hosts.
  sentry: {
    dsn: 'https://f2689b3785a6ab02192ad69c239a9919@o4511665806376960.ingest.de.sentry.io/4511665812078672',
  },
  // Firebase / GA4 — the STAGING (advocad-staging) web-app stream, kept
  // separate from live so test traffic doesn't pollute production analytics.
  firebase: {
    measurementId: 'G-WRMBN8W3G9',
  },
};
